/**
 * How long the application module may take to load before the boundary gives up WAITING on it.
 *
 * A release build evaluates an already-bundled module, which takes milliseconds; a development
 * build may fetch a lazily bundled split from Metro, which can take tens of seconds on a first
 * build. A minute covers both. On expiry the splash comes down onto the local error surface — a
 * logo held up forever is indistinguishable from a frozen phone — but a module that arrives late
 * still mounts: the error surface only shows while no application exists.
 */
export const APP_MODULE_LOAD_DEADLINE_MS = 60_000;
